define('blocks/about/about',[],function() {
    'use strict';

    var loginHost = window.cloudSettings.params.LOGIN_URL;
    var isVkSignUpEnabled = window.cloudSettings.params.FEATURES.enabled.includes('cloud-vk-signup-enable');
    var signUpBtn = document.querySelector('.js-signup.js-signup-about');
    var vkSignUpGetParam = '&cloud_vk_sign_up=true';
    var loginUrl = loginHost + '?lang=ru_RU&page=https%3A%2F%2Fcloud.mail.ru%2F%3Ffrom-page%3Dpromo%26from-promo%3Dblue-2018%26from%3Dsignin' + vkSignUpGetParam;

    if (isVkSignUpEnabled && signUpBtn) {
        signUpBtn.href = loginUrl;
    }
});

